import { SxProps, Theme } from '@mui/material'
import { brandedTokens } from '@/theme/tokens'

/** Shared FieldEditor / ContentDossier tab bar chrome (horizontal). */
export const brandedTabsSx: SxProps<Theme> = {
    backgroundColor: brandedTokens.variables.secondaryScale[10],
    '& .MuiTabs-indicator': {
        display: 'none',
    },
    '& .MuiTab-root': {
        borderBottom: 3,
        borderColor: 'transparent',
    },
    '& .MuiTab-root.Mui-selected': {
        borderColor: 'primary.main',
    },
    '& .MuiTouchRipple-root': {
        display: 'none',
    },
}

/** FieldEditor wrap layout on top of brandedTabsSx. */
export const brandedTabsWrapSx: SxProps<Theme> = {
    flex: 1,
    minWidth: 0,
    overflow: 'visible',
    '& .MuiTabs-scroller': {
        overflow: 'visible !important',
    },
    '& .MuiTabs-flexContainer': {
        flexWrap: 'wrap',
        alignItems: 'center',
    },
}
